import { com } from "../../../proto/game.pb";

export const ChatMode = com.achlid.crash.game.ChatCapabilities.Mode;
export type ChatModeValue = com.achlid.crash.game.ChatCapabilities.Mode;

export interface ChatRecord {
  senderMessageId: string;
  sentAt: number;
  playerName: string;
  avatar: string;
  text: string;
  deleted: boolean;
  deletedAt: number;
}

export type SendAttemptState =
  | "pending"
  | "acknowledged"
  | "rejected"
  | "durability-unknown";

export type UnknownSource = "timeout" | "terminal-ack";

export interface SendAttempt {
  clientMessageId: string;
  text: string;
  state: SendAttemptState;
  unknownSource?: UnknownSource;
  errorCode?: string;
  senderMessageId?: string;
}

export type HistoryPhase =
  | "idle"
  | "loading-initial"
  | "loading-older"
  | "reloading"
  | "failed";

export interface ChatController {
  mode: ChatModeValue;
  connected: boolean;
  records: ChatRecord[];
  pendingAttempts: SendAttempt[];
  ownSenderMessageIds: ReadonlySet<string>;
  historyPhase: HistoryPhase;
  hasMore: boolean;

  send: (text: string) => void;
  loadOlder: () => void;
  reloadLatest: () => void;
  retryAttempt: (clientMessageId: string) => void;
}
